var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    d: "M147.583,202.588l-97.246,26.057 c-11.444,3.067-22.683-5.557-22.683-17.405V94.422c0-8.156,5.478-15.294,13.355-17.405L169.082,42.7 c11.444-3.067,22.683,5.557,22.683,17.405v86.462C191.765,170.968,171.984,196.05,147.583,202.588z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 90.483,
    y1: 94.086,
    x2: 172.076,
    y2: 72.223
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 52.319,
    y1: 104.312,
    x2: 77.548,
    y2: 97.552
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 90.483,
    y1: 123.467,
    x2: 172.076,
    y2: 101.604
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 52.319,
    y1: 133.693,
    x2: 77.548,
    y2: 126.933
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 90.483,
    y1: 152.847,
    x2: 172.076,
    y2: 130.984
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 52.319,
    y1: 163.073,
    x2: 77.548,
    y2: 156.313
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 90.483,
    y1: 182.228,
    x2: 172.076,
    y2: 160.365
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 52.319,
    y1: 192.454,
    x2: 77.548,
    y2: 185.694
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 9,
      strokeMiterlimit: 10
    },
    cx: 194.426,
    cy: 189.995,
    r: 73.621
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10
    },
    points: " 194.426,132.242 194.426,189.995 215.714,211.283 "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 221.445,
    y1: 165.626,
    x2: 240.732,
    y2: 146.339
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 152.651,
    y1: 234.42,
    x2: 171.938,
    y2: 215.133
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 196.691,
    y1: 252.662,
    x2: 196.691,
    y2: 225.387
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 171.938,
    y1: 165.626,
    x2: 152.651,
    y2: 146.339
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 240.732,
    y1: 234.42,
    x2: 221.445,
    y2: 215.133
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 161.684,
    y1: 190.38,
    x2: 134.408,
    y2: 190.38
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 258.974,
    y1: 190.38,
    x2: 231.698,
    y2: 190.38
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 52.319,
    y1: 83.155,
    x2: 52.319,
    y2: 46.355
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 109.709,
    y1: 69.814,
    x2: 109.709,
    y2: 33.014
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 163.118,
    y1: 55.022,
    x2: 163.118,
    y2: 18.222
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon03);
export default __webpack_public_path__ + "static/media/system_icon-03.1e291628b7468fa906ef6e9e3487f594.svg";
export { ForwardRef as ReactComponent };